import gql from 'graphql-tag';
import { CatalogItemCardFragment } from '../fragments/fragments.cartEndpoint';

const ArticlesQuery = {
  getArticles: gql`
    query getArticles($page: Int, $search: String, $setLimit: Int) {
      getArticles(
        page: $page
        search: $search
        setLimit: $setLimit
        imageSizeFilter: "h315"
      ) {
        totalCount
        articlesItems {
          id
          title
          attachmentsStretchItem {
            tempFullFilePath
          }
          seo_title
          rating
          commentsCount
          attachmentsItem {
            cacheItem {
              filePath
            }
          }
        }
      }
    }
  `,
  getLastArticlesData: gql`
    query getLastArticlesData($setLimit: Int) {
      getArticles(setLimit: 1) {
        articlesItems {
          id
          title
          attachmentsStretchItem {
            tempFullFilePath
          }
          attachmentsItem {
            cacheItem {
              filePath
            }
          }
        }
      }
    }
  `,
  getArticleById: gql`
    query getArticleById($id: ID!, $cartToken: String) {
      getArticleById(id: $id, cartToken: $cartToken, imageSizeFilter: "w800") {
        id
        viewCount
        stretch_id
        attachmentsItem {
          stretchFilePath
          cacheItem {
            filePath
          }
        }
        title
        date
        rating
        commentsCount
        text
        _votedRating
        video_title
        video_code
      }
    }
  `,
  getBlogItemById: gql`
    query getBlogItemById($id: ID!) {
      getBlogItemById(id: $id) {
        id
        title
        date
        stretchItem {
          stretchFilePath
        }
        text
      }
    }
  `,
  getArticlesCommentsByArticleId: gql`
    query getArticlesCommentsByArticleId($id: ID!, $imageSizeFilter: String) {
      getArticlesCommentsByArticleId(
        imageSizeFilter: $imageSizeFilter
        id: $id
      ) {
        articlesComments {
          peopleItem {
            id
            fio
            attachmentsItem {
              cacheItem {
                filePath
              }
            }
          }
          id
          text
          date

          answer
          answer_date
          answerUserItem {
            fio
            attachmentsItem {
              cacheItem {
                id
                filePath
              }
            }
          }
        }
        totalCount
      }
    }
  `,
  getArticleRelatedCatalogItems: gql`
    query getArticleRelatedCatalogItems($articleId: Int!) {
      getArticleRelatedCatalogItems(articleId: $articleId) {
        ...CatalogItemCardFragment
      }
    }
    ${CatalogItemCardFragment}
  `,
  getArticleRelatedArticles: gql`
    query getArticleRelatedArticles($id: Int!) {
      getArticleRelatedArticles(articleId: $id, imageSizeFilter: "w800") {
        id
        title
        rating
        attachmentsItem {
          cacheItem {
            filePath
          }
        }
      }
    }
  `,
  getArticleRelatedRecipes: gql`
    query getArticleRelatedRecipes($articleId: Int!) {
      getArticleRelatedRecipes(articleId: $articleId, imageSizeFilter: "w800") {
        id
        isFavorite
        title
        rating
        text
        date
        author
        weight
        identifyIdURI
        recipes_difficult #  иконка с шапкой повара. от 1-го до 5
        slozhnostItem {
          id
          title
        }
        cooking_time # время приготовления
        rating # если 0, то "не оценен" https://www.delikateska.ru/recipes/1775
        serving # порции
        bludoItem {
          id
          title
        }
        attachmentsItem {
          cacheItem {
            filePath # путь карлито
          }
        }
      }
    }
  `
};
export default ArticlesQuery;
